const cache = {
  HEADER: { banners: null, fetchedAt: 0, inFlight: null },
  SIDEBAR: { banners: null, fetchedAt: 0, inFlight: null },
};

export async function getCachedBanners({ placement, fetcher, ttlMs = 5 * 60 * 1000 }) {
  const entry = cache[placement] ?? (cache[placement] = { banners: null, fetchedAt: 0, inFlight: null });
  const now = Date.now();

  if (entry.banners && (now - entry.fetchedAt) < ttlMs) return entry.banners;
  if (entry.inFlight) return entry.inFlight;

  entry.inFlight = (async () => {
    try {
      const banners = await fetcher(placement);
      entry.banners = Array.isArray(banners) ? banners : [];
      entry.fetchedAt = Date.now();
      return entry.banners;
    } finally {
      entry.inFlight = null;
    }
  })();

  return entry.inFlight;
}

export function invalidateBannerCache(placement) {
  if (!placement) return;
  if (cache[placement]) {
    cache[placement].banners = null;
    cache[placement].fetchedAt = 0;
  }
}
